/* Import components */

import React, {useEffect, useState} from 'react';
import {Field} from 'formik';
import {DataTable, Form} from '../components';
import {axios} from '../libs';
import {acceptFiles} from '../config';

/* Format date */

function formatDateDMY(date) {
	if (!date) return '';
	const d = new Date(date);
	const day = d.getDate().toString().padStart(2, '0');
	const month = (d.getMonth() + 1).toString().padStart(2, '0');
	const year = d.getFullYear();
	return `${day}.${month}.${year}`;
}

/* Export sheets */

export const Sheets = React.memo(() => {
	const [refetch, setrefetch] = useState(false);
	const initialValues         = {name: '', document: null,};
	
	/* Modal handlers */
	
	const [isModalOpen, setIsModalOpen] = useState(false);
	const openModal = () => { setIsModalOpen(true); };
	const closeModal = () => { setIsModalOpen(false); };
	const onSuccess = ({chatbot}) => { setrefetch(true); };
	
	/* Delete sheet */
	
	const onDelete = ({_id, name}) => {
		setrefetch(false);
		window.nConfirm({
			icon: 'fa-question-circle',
			title: 'Delete sheet?',
			text: `<span>${name}</span>`,
			onYes: () => {deleteDocument(_id);},
			onNo:  () => {}
		});
	};
	
	const deleteDocument = async (id) => {
		const deleteId = id;
		await axios.post(`/user/deleteDocument`, {deleteId});
		setrefetch(true);
	};
	
	/* Table columns */
	
	const tableColumns = [
		{
			dataField: 'name',
			text: 'Name',
			classes: 'cell-name',
			headerClasses: 'cell-name',
		},
		/*
		{
			dataField: 'createdAt',
			text: 'Created',
			classes: 'cell-created',
			headerClasses: 'cell-created',
			formatter: d => formatDateDMY(d),
		},
		*/
	];
	
	/* Render HTML */
	
	return (
		<div id="sheets" className="row table_v2 sheets">
			<div className="col p-0">
				<div className="x_panel chatbot-builder">
					<div className="header-menu d-flex justify-content-between align-items-center">
						<div className="header-title d-flex align-items-center">
							<h1>Sheets</h1>
						</div>
						<div className="header-actions d-flex align-items-center">
							<div className="action action-addnew">
								<button className="button button-blue" onClick={openModal}>
									+ Add New
								</button>
							</div>
						</div>
					</div>
					<div className="x_content">
						<div className="page-container d-flex flex-column">
							<div className="page-content">
								<DataTable
								dataKey       = "documents"
								tableHeading  = "Spreadsheets"
								url           = "/user/sheets"
								navigateTo    = "https://docs.google.com/spreadsheets/d"
								columns       = {tableColumns}
								refetch       = {refetch}
								onDelete      = {onDelete}
								defaultSorted = {[{ dataField: 'name', order: 'asc' }]}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* Modal */}
			{isModalOpen && (
				<div className="modal sheet" onClick={closeModal}>
					<div className="modal-content" onClick={e=>e.stopPropagation()}>
						<div className="modal-header">
							<span className="modalclose" onClick={closeModal}>&times;</span>
							<h2>New sheet</h2>
						</div>
						<div className="modal-form">
							<Form
							enctype       = "multipart/form-data"
							// url={isMultipart ? '/user/documents/upload' : '/user/documents'}
							url           = "/user/sheets"
							initialValues = {initialValues}
							onSuccess     = {onSuccess}
							>
								<div className="form-row col-full row-name">
									<Field id="name" placeholder="Sheet name" name="name" type="text" />
								</div>
								<div className="form-row col-full row-actions">
									<button type="button" className="button button-large" onClick={closeModal}>Cancel</button>
									<button type="submit" className="button button-large button-blue">Create</button>
								</div>
							</Form>
						</div>
					</div>
				</div>
			)}
		</div>
	);
});
